import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { AuthService } from '../../shared/services/auth.service';
import { UtilService } from '../../shared/services/util.service';

@Component({
  standalone: false,
  selector: 'app-first-mfa-setup',
  templateUrl: './first-mfa-setup.component.html',
  styleUrls: ['./first-mfa-setup.component.scss']
})
export class FirstMfaSetupComponent implements OnInit {
  userEmail: string = '';
  otp: string = '';
  errorMessage: string | null = null;
  isLoading: boolean = false;
  isSetupComplete: boolean = false;
  
  setupDetails: { secret: string, qrCode: string } | null = null;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private utilService: UtilService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Get user email from auth service
    const user = this.authService.getUser();
    if (user && user.email) {
      this.userEmail = user.email;
      // Initiate MFA setup for first-time users
      this.initiateMfaSetup();
    } else {
      // Redirect to login if no user data
      this.router.navigate(['/']);
    }
  }

  initiateMfaSetup(): void {
    this.errorMessage = null;
    this.apiService.postData('/users/totp-mfa/setup', { email: this.userEmail }).subscribe((res: any) => {
      if (res && !res.error) {
        this.setupDetails = res.data;
      } else {
        this.errorMessage = 'Failed to initiate MFA setup. Please try again.';
      }
    }, (error) => {
      this.errorMessage = 'Failed to initiate MFA setup. Please try again.';
    });
  }

  onOtpInput(event: any): void {
    const value = event.target.value;
    // Allow only numeric values and limit to 6 digits
    if (/^\d*$/.test(value) && value.length <= 6) {
      this.otp = value;
    }
  }

  verifyAndEnableMfa(): void {
    if (!this.setupDetails || !this.otp) {
      return;
    }
    
    if (this.otp.length !== 6) {
      this.errorMessage = 'Please enter a valid 6-digit code';
      return;
    }
    
    this.errorMessage = null;
    this.isLoading = true;

    const payload = {
      email: this.userEmail,
      token: this.otp,
      secret: this.setupDetails.secret
    };

    this.apiService.postData('/users/totp-mfa/verify-setup', payload).subscribe((res: any) => {
      this.isLoading = false;
      if (res && !res.error) {
        this.isSetupComplete = true;
        // Update user data to indicate first login is complete and MFA is verified
        const user = this.authService.getUser();
        if (user) {
          user.firstLogin = false;
          user.isMfaEnabled = true;
          user.mfaVerified = true;
          this.authService.setUser(user);
        }
      } else {
        this.errorMessage = res.message || 'Invalid token. Please try again.';
      }
    }, (error) => {
      this.isLoading = false;
      this.errorMessage = 'Verification failed. Please try again.';
    });
  }

  continueToDashboard(): void {
    this.utilService.navigate('/app');
  }

  cancelSetup(): void {
    // Clear user data and redirect to login
    this.authService.logout();
  }
}